// client/src/constants/adminProductConstants.js

export const ADMIN_PRODUCT_LIST_REQUEST = "ADMIN_PRODUCT_LIST_REQUEST";
export const ADMIN_PRODUCT_LIST_SUCCESS = "ADMIN_PRODUCT_LIST_SUCCESS";
export const ADMIN_PRODUCT_LIST_FAIL = "ADMIN_PRODUCT_LIST_FAIL";
export const ADMIN_PRODUCT_LIST_RESET = "ADMIN_PRODUCT_LIST_RESET";

export const ADMIN_PRODUCT_DETAILS_REQUEST = "ADMIN_PRODUCT_DETAILS_REQUEST";
export const ADMIN_PRODUCT_DETAILS_SUCCESS = "ADMIN_PRODUCT_DETAILS_SUCCESS";
export const ADMIN_PRODUCT_DETAILS_FAIL = "ADMIN_PRODUCT_DETAILS_FAIL";
export const ADMIN_PRODUCT_DETAILS_RESET = "ADMIN_PRODUCT_DETAILS_RESET";

export const ADMIN_PRODUCT_CREATE_REQUEST = "ADMIN_PRODUCT_CREATE_REQUEST";
export const ADMIN_PRODUCT_CREATE_SUCCESS = "ADMIN_PRODUCT_CREATE_SUCCESS";
export const ADMIN_PRODUCT_CREATE_FAIL = "ADMIN_PRODUCT_CREATE_FAIL";
export const ADMIN_PRODUCT_CREATE_RESET = "ADMIN_PRODUCT_CREATE_RESET";

export const ADMIN_PRODUCT_UPDATE_REQUEST = "ADMIN_PRODUCT_UPDATE_REQUEST";
export const ADMIN_PRODUCT_UPDATE_SUCCESS = "ADMIN_PRODUCT_UPDATE_SUCCESS";
export const ADMIN_PRODUCT_UPDATE_FAIL = "ADMIN_PRODUCT_UPDATE_FAIL";
export const ADMIN_PRODUCT_UPDATE_RESET = "ADMIN_PRODUCT_UPDATE_RESET";

export const ADMIN_PRODUCT_DELETE_REQUEST = "ADMIN_PRODUCT_DELETE_REQUEST";
export const ADMIN_PRODUCT_DELETE_SUCCESS = "ADMIN_PRODUCT_DELETE_SUCCESS";
export const ADMIN_PRODUCT_DELETE_FAIL = "ADMIN_PRODUCT_DELETE_FAIL";
export const ADMIN_PRODUCT_DELETE_RESET = "ADMIN_PRODUCT_DELETE_RESET";

export const ADMIN_PRODUCT_SET_STATUS_REQUEST =
  "ADMIN_PRODUCT_SET_STATUS_REQUEST";
export const ADMIN_PRODUCT_SET_STATUS_SUCCESS =
  "ADMIN_PRODUCT_SET_STATUS_SUCCESS";
export const ADMIN_PRODUCT_SET_STATUS_FAIL = "ADMIN_PRODUCT_SET_STATUS_FAIL";
export const ADMIN_PRODUCT_SET_STATUS_RESET = "ADMIN_PRODUCT_SET_STATUS_RESET";

/* -------------------------------------------------------------------------- */
/*                           Backwards compatibility                          */
/* -------------------------------------------------------------------------- */

export const ADMIN_PRODUCT_UNPUBLISH_REQUEST =
  "ADMIN_PRODUCT_UNPUBLISH_REQUEST";
export const ADMIN_PRODUCT_UNPUBLISH_SUCCESS =
  "ADMIN_PRODUCT_UNPUBLISH_SUCCESS";
export const ADMIN_PRODUCT_UNPUBLISH_FAIL = "ADMIN_PRODUCT_UNPUBLISH_FAIL";
export const ADMIN_PRODUCT_UNPUBLISH_RESET = "ADMIN_PRODUCT_UNPUBLISH_RESET";

export const ADMIN_PRODUCT_RESTORE_REQUEST = "ADMIN_PRODUCT_RESTORE_REQUEST";
export const ADMIN_PRODUCT_RESTORE_SUCCESS = "ADMIN_PRODUCT_RESTORE_SUCCESS";
export const ADMIN_PRODUCT_RESTORE_FAIL = "ADMIN_PRODUCT_RESTORE_FAIL";
export const ADMIN_PRODUCT_RESTORE_RESET = "ADMIN_PRODUCT_RESTORE_RESET";
